const API_URL =
    process.env.REACT_APP_API_URL ||
    "https://api.cuahangykhoa.com";


/*
 * LẤY USER HIỆN TẠI
 */
export const getPatientProfileUser = () => {

    try {

        const rawUser =
            localStorage.getItem("user");

        if (!rawUser) {
            return null;
        }

        return JSON.parse(rawUser);

    } catch (error) {

        console.error(
            "Không thể đọc user:",
            error
        );

        return null;
    }
};


/*
 * LẤY TOKEN
 */
export const getPatientProfileToken = () => {

    const user =
        getPatientProfileUser();

    let token =
        user?.token ||
        user?.accessToken ||
        localStorage.getItem("token") ||
        "";

    if (
        typeof token !== "string"
    ) {
        return "";
    }

    token =
        token.trim();

    if (
        token.toLowerCase().startsWith("bearer ")
    ) {
        token =
            token.slice(7).trim();
    }

    return token;
};


/*
 * KIỂM TRA CÓ THỂ ĐỒNG BỘ DATABASE KHÔNG
 */
export const canSyncPatientProfile = () => {

    return Boolean(
        getPatientProfileToken()
    );
};


/*
 * HEADER CHUNG
 */
const getHeaders = () => {

    const token =
        getPatientProfileToken();

    return {
        "Content-Type": "application/json",

        Authorization:
            token
                ? `Bearer ${token}`
                : "",

        "Cache-Control": "no-cache",

        Pragma: "no-cache"
    };
};


/*
 * CHỜ TOKEN
 * HỮU ÍCH KHI VỪA ĐĂNG NHẬP XONG
 */
const waitForToken = async () => {

    for (
        let i = 0;
        i < 5;
        i++
    ) {

        const token =
            getPatientProfileToken();

        if (token) {
            return token;
        }

        await new Promise(
            (resolve) =>
                setTimeout(
                    resolve,
                    200
                )
        );
    }

    return "";
};


/*
 * LẤY DANH SÁCH HỒ SƠ
 */
export const getPatientProfiles = async () => {

    await waitForToken();

    const response =
        await fetch(
            `${API_URL}/patient-profile/getAll?_t=${Date.now()}`,
            {
                method: "GET",
                headers: getHeaders()
            }
        );


    if (!response.ok) {

        const text =
            await response.text();

        throw new Error(
            text ||
            "Không thể lấy danh sách hồ sơ."
        );
    }


    const result =
        await response.json();


    return (
        result?.data ||
        []
    );
};


/*
 * LẤY CHI TIẾT 1 HỒ SƠ
 */
export const getPatientProfileById = async (
    profileId
) => {

    await waitForToken();

    const response =
        await fetch(
            `${API_URL}/patient-profile/getById/${profileId}?_t=${Date.now()}`,
            {
                method: "GET",
                headers: getHeaders()
            }
        );


    if (!response.ok) {

        const text =
            await response.text();

        throw new Error(
            text ||
            "Không thể lấy hồ sơ."
        );
    }


    const result =
        await response.json();


    return (
        result?.data ||
        null
    );
};


/*
 * TẠO HỒ SƠ
 */
export const createPatientProfile = async (
    data
) => {

    await waitForToken();

    const response =
        await fetch(
            `${API_URL}/patient-profile/create`,
            {
                method: "POST",

                headers:
                    getHeaders(),

                body:
                    JSON.stringify({
                        profile_name:
                            data.profile_name,

                        relationship:
                            data.relationship || "",

                        note:
                            data.note || ""
                    })
            }
        );


    if (!response.ok) {

        let message =
            "Không thể tạo hồ sơ.";

        try {

            const errorData =
                await response.json();

            message =
                errorData?.message ||
                message;

        } catch (error) {

            const text =
                await response.text();

            if (text) {
                message = text;
            }
        }

        throw new Error(message);
    }


    return await response.json();
};


/*
 * CẬP NHẬT HỒ SƠ
 */
export const updatePatientProfile = async (
    profileId,
    data
) => {

    await waitForToken();

    const response =
        await fetch(
            `${API_URL}/patient-profile/update/${profileId}`,
            {
                method: "PUT",

                headers:
                    getHeaders(),

                body:
                    JSON.stringify({
                        profile_name:
                            data.profile_name,

                        relationship:
                            data.relationship || "",

                        note:
                            data.note || ""
                    })
            }
        );


    if (!response.ok) {

        let message =
            "Không thể cập nhật hồ sơ.";

        try {

            const errorData =
                await response.json();

            message =
                errorData?.message ||
                message;

        } catch (error) {

            const text =
                await response.text();

            if (text) {
                message = text;
            }
        }

        throw new Error(message);
    }


    return await response.json();
};


/*
 * XÓA HỒ SƠ
 */
export const deletePatientProfile = async (
    profileId
) => {

    await waitForToken();

    const response =
        await fetch(
            `${API_URL}/patient-profile/delete/${profileId}`,
            {
                method: "DELETE",
                headers: getHeaders()
            }
        );


    if (!response.ok) {

        let message =
            "Không thể xóa hồ sơ.";

        try {

            const errorData =
                await response.json();

            message =
                errorData?.message ||
                message;

        } catch (error) {

            const text =
                await response.text();

            if (text) {
                message = text;
            }
        }

        throw new Error(message);
    }


    return await response.json();
};


/*
 * HỒ SƠ ĐANG ĐƯỢC CHỌN
 */
export const getActivePatientProfileId = () => {

    const value =
        localStorage.getItem(
            "activePatientProfileId"
        );

    if (!value) {
        return null;
    }

    const id =
        Number(value);

    if (
        !id ||
        Number.isNaN(id)
    ) {
        return null;
    }

    return id;
};


/*
 * LƯU HỒ SƠ ĐANG CHỌN
 */
export const setActivePatientProfileId = (
    profileId
) => {

    if (!profileId) {

        localStorage.removeItem(
            "activePatientProfileId"
        );

        return;
    }


    localStorage.setItem(
        "activePatientProfileId",
        String(profileId)
    );
};


/*
 * XÓA HỒ SƠ ĐANG CHỌN
 */
export const clearActivePatientProfile = () => {

    localStorage.removeItem(
        "activePatientProfileId"
    );
};